/* Version: 3.5.149 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var membersIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M16.433 3.533C13.133.2 7.833-.067 4.2 2.9c-.233.2-.467.4-.667.633a9.114 9.114 0 0 0 0 12.9c.1.1.167.167.267.234.1.066.267.266.433.4l.234.166a9.053 9.053 0 0 0 11.033 0 5.44 5.44 0 0 0 .667-.566c.1-.067.166-.167.266-.234 3.6-3.566 3.567-9.333 0-12.9zm-6.466 13.6c-1.5 0-2.967-.466-4.2-1.366.1-2.3 2.033-4.1 4.366-4.034 2.2.1 3.934 1.834 4.034 4.034-1.2.9-2.667 1.366-4.2 1.366zm1.1-7.866a1.429 1.429 0 0 1-2.034 0 1.429 1.429 0 0 1 0-2.034 1.429 1.429 0 0 1 2.034 0c.533.567.533 1.5 0 2.034zm4.8 4.7c-.5-1.6-1.634-2.9-3.134-3.634 1.167-1.5.9-3.666-.6-4.833a3.446 3.446 0 0 0-4.833.6 3.404 3.404 0 0 0 0 4.2 6.268 6.268 0 0 0-3.233 3.667 7.119 7.119 0 0 1 1.866-9.9 7.119 7.119 0 0 1 9.9 1.866 7.021 7.021 0 0 1 .034 8.034z"
      })
    })]
  });
});

export { membersIcon as default };
